<template>
  <div class="dialog-root">
    <div class="container">
      <el-form ref="formRef" :model="formData" label-width="130px">
        <el-row>
          <el-col span="12">
            <el-form-item
              prop="code"
              label="电表表号："
              :rules="[{ required: true, message: '请输入电表表号', trigger: 'blur' }]"
            >
              <el-input
                v-model="formData.code"
                placeholder="请输入 电表表号"
                maxlength="30"
                show-word-limit
                clearable
                :disabled="dialogType == 'add' ? false : true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="propertyId"
              label="关联房产："
              :rules="[{ required: true, message: '请选择关联房产', trigger: 'blur' }]"
            >
              <LazyTree
                placeholder="请选择 关联房产"
                @load="getPropertyTreeData"
                :selectedName.sync="formData.propertyName"
                :selectedId.sync="formData.propertyId"
                :treeProps="{
                  label: 'objectFullName',
                  value: 'id',
                }"
              ></LazyTree>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="unitPrice"
              label="单价："
              :rules="[{ required: true, message: '请输入单价', trigger: 'blur' }]"
            >
              <moneyInput
                v-model="formData.unitPrice"
                placeholder="请输入 单价"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="lastEndNum"
              label="电表止码："
              :rules="[{ required: true, message: '请输入电表止码', trigger: 'blur' }]"
            >
              <moneyInput
                v-model="formData.lastEndNum"
                placeholder="请输入 电表止码"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="balance"
              label="初始余额："
              :rules="[{ required: true, message: '请输入初始余额', trigger: ['blur', 'change'] }]"
            >
              <moneyInput
                v-model="formData.balance"
                placeholder="请输入 初始余额"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="alarmBalance"
              label="余额预警值："
              :rules="[
                { required: true, message: '请输入余额预警值', trigger: ['blur', 'change'] },
              ]"
            >
              <moneyInput
                v-model="formData.alarmBalance"
                placeholder="请输入 余额预警值"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">
        {{ dialogType == 'add' ? '保存' : '修改' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import LazyTree from '@/views/components/lazy-tree';
import { getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';
import { addApi, updateApi } from '@/api/electric-meter/electric-meter-management';

export default {
  props: ['dialogType', 'rowData'],
  components: {
    LazyTree,
  },
  data() {
    return {
      formData: {}, // 表单数据
    };
  },
  created() {
    if (this.dialogType == 'edit') {
      this.formData = Object.assign({}, this.rowData);
    }
    this.checkDefaultVal();
  },
  methods: {
    /* 加载房产树的数据 */
    getPropertyTreeData(node, resolve) {
      getTreeChildrenPowerNode({
        id: node.level == 0 ? 0 : node.data.id,
        power: 1,
      }).then(({ data }) => {
        resolve(data);
      });
    },
    /*  校正默认值 */
    checkDefaultVal() {
      if (!this.formData.balance) {
        this.formData = Object.assign({}, this.formData, { balance: 0 });
      }
      if (!this.formData.alarmBalance) {
        this.formData = Object.assign({}, this.formData, { alarmBalance: 0 });
      }
    },
    /* 保存 */
    doSave() {
      this.checkDefaultVal();
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let fn = this.dialogType == 'add' ? addApi : updateApi;
          fn(this.formData, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
</style>
